import { lazy } from "react";
import { connect } from "react-redux";
import {
  loading,
  data,
} from "../../../../store/administration/selectors/areas";

const NewArea = lazy(() => import("./NewArea"));

const mapStateToProps = (state) => ({
  loading: loading(state),
  areas: data(state),
});

export default connect(mapStateToProps)(NewArea);
